import AccountDefaults from '@configs/accountDefaults';
import AccountService from '@services/account.service';
import OrganizationService from '@services/organization.service';
import namespaceService from '@services/namespace.service';
import configService from '@services/config.service';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth } from './AuthContext';
const AccountContext = createContext(AccountDefaults);
export const useAccountContext = () => useContext(AccountContext);
const AccountProvider = ({ children }) => {
    const tahoeUrl = configService.TahoeUrl;
    const accountService = new AccountService(tahoeUrl);
    const organizationService = new OrganizationService(configService.OrganizationServiceBaseUrl);
    const namespace = namespaceService.getNamespace();
    const [account, setAccount] = useState(AccountDefaults);
    const [brand, setBrand] = useState('');
    const { isAuthenticated, isAuthLoading } = useAuth();
    const getAccount = async () => {
        const response = await accountService.getAccount();
        setAccount(response);
    };
    useEffect(() => {
        // Wait for auth loading to complete
        if (isAuthLoading) {
            return;
        }
        // Only load account if authenticated
        if (isAuthenticated) {
            getAccount();
        }
    }, [isAuthenticated, isAuthLoading]); //eslint-disable-line react-hooks/exhaustive-deps
    useEffect(() => {
        const getBrand = async () => {
            const { brand } = await organizationService.GetBrandByNamespace(namespace);
            setBrand(brand);
        };
        // Only load brand if authenticated and account is loaded and namespace exists
        if (isAuthenticated && account && namespace?.length) {
            getBrand();
        }
    }, [account, namespace, isAuthenticated]);
    const values = useMemo(() => ({
        ...account,
        brand,
    }), [account, brand]);
    return (<AccountContext.Provider value={values}>
            <>{children}</>
        </AccountContext.Provider>);
};
export default AccountProvider;
